import { useDatabaseContent } from '@databases/database-state';
import { messages } from '@databases/intl/messages';
import usePanel from '@databases/panel/usePanel';
import { defaultStoreUtils } from '@databases/redux';
import { getService } from '@databases/service-container';
import { currentSnackbarState } from '@databases/snackbar/snackbar';
import {
  getDatabaseEntryOptional,
  isBrokenDatabase,
} from '@databases/utils/database/utils';
import { selectDatabaseByContentIdRequired } from '@databases/utils/redux/databases/selectors';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl-next';

/**
 * This particular hook being so high up in the application causes every child to re-render
 * when the panel state changes. This should be moved.
 *
 * @deprecated This will become an event listener on panel state changes.
 */
export const useEntryPanel = ({ contentId }: { contentId: string }) => {
  const { entryId } = useDatabaseContent();
  const [isLoaded, setIsLoaded] = useState(false);
  const selectionsActions = getService('SelectionsActions');

  const { showPanel } = usePanel();

  const intl = useIntl();
  const { formatMessage } = intl;

  const entryExists = defaultStoreUtils.useEqualSelector((state) => {
    const database = selectDatabaseByContentIdRequired(state, { contentId });
    const entry = entryId
      ? database &&
        !isBrokenDatabase(database) &&
        getDatabaseEntryOptional(database, entryId)
      : null;

    return !!entry;
  });

  useEffect(() => {
    if (!isLoaded && entryId && entryExists) {
      showPanel('EntryViewPanel', {
        entryId,
      });

      selectionsActions.selectEntries([entryId]);
    } else if (entryId && !entryExists) {
      void currentSnackbarState.setMessage(
        formatMessage(messages['snackbar-error.deleted-linked-entry']),
        {
          id: 'linked-database-entry-deleted',
          type: 'info',
          showCloseButton: true,
        }
      );
    }
    setIsLoaded(true);
  }, [entryExists, entryId, formatMessage, isLoaded, selectionsActions, showPanel]);
};
